
































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({ components: {} })
export default class AtencionesTab extends Vue {
  @Prop({ required: true, default: {} }) data!: any;
}
